<template>
    <div class="advance-settings-inner-wrapper">
        <v-row>
            <v-col md="6" sm="6" cols="12">
                <div class="settings-switches-field">
                    <ul>
                        <li>
                            <p>Enable Filter Option</p>
                            <v-switch v-model="switch1"></v-switch>
                        </li>
                        <li>
                            <p>Enable Search Option</p>
                            <v-switch v-model="switch2"></v-switch>
                        </li>
                        <li>
                            <p>Enable Group Chat</p>
                            <v-switch v-model="switch2"></v-switch>
                        </li>
                        <li>
                            <p>Show Attendee List</p>
                            <v-switch v-model="switch2"></v-switch>
                        </li>
                        <li>
                            <p>Host Legend</p>
                            <input type="text"/>
                        </li>
                        <li>
                            <p>Text When Table is Full</p>
                            <input type="text"/>
                        </li>
                    </ul>
                </div>
            </v-col>
            <v-col md="6" sm="6" cols="12">
                <div class="settings-switches-field">
                    <ul>
                        <li>
                            <p>Show Guest List</p>
                            <v-switch v-model="switch1"></v-switch>
                        </li>
                        <li>
                            <p>Allow Screen Share</p>
                            <v-switch v-model="switch2"></v-switch>
                        </li>
                        <li>
                            <p>Allow Recording</p>
                            <v-switch v-model="switch2"></v-switch>
                        </li>
                        <li>
                            <p>Auto Start Recording</p>
                            <v-switch v-model="switch2"></v-switch>
                        </li>
                        <li>
                            <p>Text to Grab a Seat</p>
                            <input type="text"/>
                        </li>
                        <li>
                            <p>Text to Allow Audience to View</p>
                            <input type="text"/>
                        </li>
                    </ul>
                </div>
            </v-col>
            <v-col md="12" sm="12" cols="12">
                <div class="w-100 d-flex justify-content-end align-items-center submit-switch-section">
                    <v-btn dark color="#1a73e8" width="120px" class="save-standard">Submit</v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            switch1: false,
            switch2: true,
        };
    },
    created() {

    },
    watch: {
    },
    methods:{

    },

}
</script>
